import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import colors from './Colored.colors'

const Wrapper = styled.div`
    border-radius: 5px;
    font-size: 13px;
    line-height: 22px;
    text-align: center;
    text-overflow: ellipsis;
    overflow: hidden;

    ${({ fit }) => (fit ? `padding: 0 10px; width: fit-content;` : `width: 100%;`)}
    ${({ center }) => center && `margin: 0 auto;`}
  ${({ color }) => `
    background: ${colors[color].background};
    color: ${colors[color].color};
  `}
`

const Colored = ({ children, color, ...props }) => (
    <Wrapper color={color} {...props}>
        {children}
    </Wrapper>
)

Colored.propTypes = {
    center: PropTypes.bool,
    children: PropTypes.node.isRequired,
    color: PropTypes.oneOf(Object.keys(colors)),
    fit: PropTypes.bool,
}

Colored.defaultProps = {
    center: false,
    color: 'white',
    fit: false,
}

export default Colored
